import React, { useContext, useEffect, useState } from "react";
import {
    Flex,
    Stack,
    Box,
    Heading,
    Button,
    Table,
    Thead,
    Tbody,
    useColorModeValue,
    Tr,
    Th,
    Td,
    ButtonGroup,
    Text,
    useDisclosure,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    Select,
    Alert,
    AlertIcon,
} from "@chakra-ui/react";
import UserContext from "../State/UserContext";

export default function Gestion() {
    const initialRef = React.useRef();
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [modalTitle, setModalTitle] = useState();
    const [modalBody, setModalBody] = useState();
    const [customButton, setCustomButton] = useState();
    const [tableData, setTableData] = useState();
    const [userRoles, setUserRoles] = useState(); 
    const [statusAlert, setStatusAlert] = useState();
    const { user } = useContext(UserContext);
    var roleToChange = {};


    useEffect(() => {
        getTableData();
        getUserRoles();
    }, [])

    async function getTableData() {
        var retries = 0;
        var response = await fetch("provider/getUsers", {
            method: "POST",
            headers: { "Content-Type": "application/json", "userToken": user.token }
        }).catch(function (error) {
            if (retries < 3) {
                getTableData();
            } else {
                throw error;
            }
        });
        var data = await response.json();
        setTableData(data);
    }

    async function getUserRoles() {
        var retries = 0;
        var response = await fetch("provider/getUserRoles", {
            method: "POST",
            headers: { "Content-Type": "application/json", "userToken": user.token }
        }).catch(function (error) {
            if (retries < 3) {
                getTableData();
            } else {
                throw error;
            }
        });
        var data = await response.json();
        setUserRoles(data);
    }

    function aproveModal(userId) {
        onOpen();
        setModalTitle("Autorizar usuario");
        setModalBody(
            <Text>Seguro que desea autorizar este usuario?</Text>
        );
        setCustomButton(
            <Button colorScheme="blue" mr={3} onClick={() => aprove(userId)}>Autorizar</Button>
        );
    }

    function changeRoleModal(userId) {
        onOpen();
        setModalTitle("Cambiar Rol");
        setModalBody(
            <div>
                <Text>Seleccione el rol al que desea cambiar</Text>
                <Select
                    id="roleToChange"
                    name="roleToChange"
                    autoComplete="roleToChange"
                    placeholder="Seleccione opcion"
                    mt={1}
                    focusBorderColor="brand.400"
                    shadow="sm"
                    size="sm"
                    w="full"
                    rounded="md"
                    value={roleToChange.name}
                    onChange={(e) => handleRoleChange(e.target.value)}
                >
                    {userRoles.map((role) => (
                        <option type="checkbox" name="categoryId" value={role.id}>
                            {role.name}
                        </option>
                    ))}
                </Select>
            </div>);
        setCustomButton(
            <Button colorScheme="blue" mr={3} onClick={() => changeRole(userId)}>Cambiar Rol</Button>
        );
    }

    async function aprove(userId) {
        var response = await fetch("provider/approveUser?userId=" + userId, {
            method: "POST",
            headers: { "Content-Type": "application/json", "userToken": user.token }
        });
        var data = await response.json();
        switch (data.error) {
            case false:
                getTableData();
                break;
            case true:
                setStatusAlert(
                    <Alert status="warning" borderRadius="5px">
                        <AlertIcon />
                        {data.message}
                    </Alert>
                );
                break;
            default:
                break;
        }
        onClose();
    }

    async function changeRole(userId) {
        var response = await fetch("provider/changeUserRole?roleId=" + roleToChange + "&userId=" + userId, {
            method: "POST",
            headers: { "Content-Type": "application/json", "userToken": user.token }
        });
        var data = await response.json();
        switch (data.error) {
            case false:
                getTableData();
                break;
            case true:
                setStatusAlert(
                    <Alert status="warning" borderRadius="5px">
                        <AlertIcon />
                        {data.message}
                    </Alert>
                );
                break;
            default:
                break;
        }
        roleToChange = {};
        onClose();
    }

    function handleRoleChange(value) {
        roleToChange = value;
        console.log(JSON.stringify(roleToChange));
    }

    return (
        <Flex
            height="100vh"
            alignItems="center"
            justifyContent="center"
            backgroundColor="gray.100"
        >
            <Stack
                direction={{ base: "column" }}
                bg={{ md: "white" }}
                shadow="lg"
                w="160vh"
                h="90vh"
                rounded={'xl'}
            >
                <Stack align={'center'} spacing={2} p="50px">
                    <Heading
                        textTransform={'uppercase'}
                        fontSize={'3xl'}
                        color={useColorModeValue('gray.600', 'gray.200')}>
                        Configuracion de usuarios
                    </Heading>
                    <Text textAlign="center" fontSize={'lg'} color={'gray.600'}>
                        Lista completa de los usuarios
                    </Text>
                </Stack>
                <Box overflow="auto">
                    <Table variant="simple" overflowY="auto" overflow="scroll">
                        <Thead>
                            <Tr>
                                <Th>Nombre</Th>
                                <Th>Apellido</Th>
                                <Th>Tipo Documento</Th>
                                <Th>Numer Documento</Th>
                                <Th>Email</Th>
                                <Th>Cuit Proveedor</Th>
                                <Th>Nombre Proveedor</Th>
                                <Th>Estado</Th>
                                <Th>Rol</Th>
                            </Tr>
                        </Thead>
                        <Tbody overflow="scroll" size="md">
                            {tableData?.map((person, pid) => {
                                return (
                                    <Tr>
                                        <Td>{person.name}</Td>
                                        <Td>{person.lastName}</Td>
                                        <Td>{person.docType}</Td>
                                        <Td>{person.docNumber}</Td>
                                        <Td>{person.email}</Td>
                                        <Td>{person.providerCuit}</Td>
                                        <Td>{person.providerName}</Td>
                                        <Td>{person.status === "0" ? "Pendiente" : person.status === "1" ? "Autorizado" : "Eliminado"}</Td>
                                        <Td>{person.rol.name}</Td>
                                        <Td>
                                            <ButtonGroup variant="solid" size="sm" spacing={2}>
                                                <Button disabled={person.status === "1" } variant="solid" colorScheme="blue" size="sm" onClick={() => aproveModal(person.id)}> Autorizar </Button>
                                                <Button disabled={person.id === user.user?.id} variant="solid" colorScheme="blue" size="sm" onClick={() => changeRoleModal(person.id)}> Cambiar Rol </Button>
                                            </ButtonGroup>
                                        </Td>
                                    </Tr>
                                );
                            })}
                        </Tbody>
                    </Table>
                    {statusAlert}
                </Box>
                <Modal isOpen={isOpen} onClose={onClose} initialFocusRef={initialRef}>
                    <ModalOverlay />
                    <ModalContent>
                        <ModalHeader>{modalTitle}</ModalHeader>
                        <ModalCloseButton />
                        <ModalBody>
                            {modalBody}
                        </ModalBody>
                        <ModalFooter>
                            {customButton}
                            <Button colorScheme="blue" mr={3} onClick={onClose}>
                                Cerrar
                            </Button>
                        </ModalFooter>
                    </ModalContent>
                </Modal>
            </Stack>
        </Flex>
    );
}

